var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"clearfix"}),_c('div',{staticClass:"page-container"},[_vm._t("content")],2),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }